// 公用部分
export default {
    totals: 'Total',
    phoneNumber: 'Phone Number',
    add: 'Add',
    new: 'New',
    edit: 'Edit',
    del: 'Delete',
    delete: 'Delete',
    BD: 'Batch deletion',
    cancel: 'Cancel',
    ok: 'OK',
    save: 'Save',
    numbering: 'Numbering',
    remarks: 'Remarks',
    details: 'Details',
    description: 'Description',
    start: 'Start',
    complete: 'Complete',
    return: 'Return',
    preservation: 'Preservation',
    upload: 'Upload',
    download: 'Download',
    bulkDownload: 'Bulk download',
    getSuccess: 'Success',
    setSuccess: 'Set successfully',
    uploadSuccess: 'Upload success',
    editSuccess: 'Edit successful',
    addSuccess: 'Successfully added',
    RC: 'Read complete',
    tip: 'Tips',
    warning: 'Warning',
    send: 'Has been sent',
    saved: 'Have been saved',
    deleteSuccessful: 'Delete successful',
    deleteSuccess: 'Delete succeeded',
    on: 'On',
    off: 'Off',
    success: 'success',
    failure: 'failure',
    odifiedSuccess: 'Modified success',
    selectUAV: 'Please select UAV',
    tip_pleaseEnterLng: 'Please enter longitude',
    tip_pleaseEnterLat: 'Please enter latitude',
    tip_pleaseEnterAlt: 'Please enter altitude',
    tip_lngFormatErr: 'Incorrect longitude format, please re-enter',
    tip_latFormatErr: 'Latitude format error, please re-enter',
    tip_altFormatErr: 'Altitude format error, please re-enter',
    tip_altMaxErr: "The altitude exceeds the system's maximum altitude of 9999",
    lngFormat: 'The longitude range is -180~180, please re-enter.',
    latFormat: 'The latitude range is -90~90, please re-enter.',
    confirmRevision: 'Are you sure to modify?',
    reset: 'Reset',
    search: 'Search',
    query: 'Query',
    filter: 'Filter',
    operation: 'Operation',
    use: 'Use',
    returnstation: 'Return to Ground Station',
    ND: 'No data',
    time: 'Time',
    startTime: 'Start Time',
    to: 'To',
    loading: 'Loading',
    empty: 'Empty',
    selectAll: 'Select All',
    export: 'Export',
    select: 'Select',
    lng: 'Lng',
    lat: 'Lat',
    folder: 'folder',
    file: 'file',
    height: 'Height',
    altitude: 'Altitude',
    relativeHeight: 'Relative Height',
    elevation: 'Altitude',
    speed: 'Speed',
    groundSpeed: 'Ground Speed',
    airspeed: 'Airspeed',
    radius: 'Radius',
    setUp: 'Set up',
    digitalMap: 'Digital Map',
    satelliteMap: 'Satellite Map',
    level: '{name} level',
    online: 'Online {0}',
    offline: 'Offline {0}',
    total: 'Total {0}',
    uav: 'UAV',
    rtk: 'RTK',
    baseStation: 'Base Station',
    weatherStation: 'Weather Station',
    noFlyZone: 'no-fly zone',
    restrictedFlyArea: 'Restricted Fly Area',
    all: 'All',
    taskNumber: 'Task Number',
    creationTime: 'Creation Time',
    founder: 'Founder',
    deadline: 'Deadline',
    startingTime: 'Starting Time',
    completeTime: 'Complete Time',
    endTime: 'End Time',
    workLocation: 'Work Location',
    taskType: 'Task Type',
    state: 'State',
    mapView: 'Map View',
    copy: 'Copy',
    paste: 'Paste',
    saveAndExit: 'Save And Exit',
    hide: 'Hide',
    show: 'Show',
    notInstalled: 'Not Installed',
    unknown: 'Unknown',

    // 气象站相关
    windSpeed: 'Wind Speed',
    windDirection: 'Wind Direction',
    temperature: 'Temperature',
    humidity: 'Humidity',
    airPressure: 'Air Pressure',

    // 任务类型
    pointReconnaissance: 'Point reconnaissance',
    regionalReconnaissance: 'Regional reconnaissance',
    orthophoto: 'Orthophoto',
    tiltPhotography: 'Tilt photography',
    logisticsTransportation: 'Logistics transportation',

    tip_del: 'Are you sure you want to delete?',
    tip_revoke: 'Are you sure you want to cancel?',
    tip_recover: 'Are you sure about recovery?',
    rightClickDelete: 'right click delete me',
    tip_deletePermanently: 'This operation will permanently delete the data. Do you want to continue?',
    tip_SDT: 'Select date time',
}